"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _hooks = require("../../hooks");

var _Tab = _interopRequireDefault(require("./Tab/Tab"));

var _Tabs = require("./Tabs.styles");

var _elements = require("../../styles/elements");

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      activeKey = _ref.activeKey,
      defaultActiveKey = _ref.defaultActiveKey,
      type = _ref.type,
      className = _ref.className,
      onChange = _ref.onChange,
      onGoBack = _ref.onGoBack;

  // Put all refs into a Map and provide getting ref function
  var _useRefs = (0, _hooks.useRefs)(),
      _useRefs2 = (0, _slicedToArray2["default"])(_useRefs, 1),
      getTabRef = _useRefs2[0];

  var _useState = (0, _react.useState)(activeKey || defaultActiveKey || tabs[0].key),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      mergedActiveKey = _useState2[0],
      setMergedActiveKey = _useState2[1];

  var activeTabRef = getTabRef(mergedActiveKey); // For animating ink bar

  var _useState3 = (0, _react.useState)({
    left: '0px',
    width: '0px'
  }),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      inkBarStyle = _useState4[0],
      setInkBarStyle = _useState4[1];

  (0, _react.useLayoutEffect)(function () {
    if (!activeTabRef.current) return;
    var _activeTabRef$current = activeTabRef.current,
        left = _activeTabRef$current.offsetLeft,
        width = _activeTabRef$current.clientWidth;
    setInkBarStyle({
      left: "".concat(left, "px"),
      width: "".concat(width, "px")
    }); // Add tabs as a dependency, so can change left and width if the titles are changed
  }, [activeKey, setInkBarStyle, activeTabRef, tabs]);
  (0, _react.useEffect)(function () {
    if (activeKey && activeKey !== mergedActiveKey) {
      onChange(activeKey);
      setMergedActiveKey(activeKey);
    }
  }, [activeKey, mergedActiveKey, onChange]);
  var handleClickTab = (0, _react.useCallback)(function (key) {
    setMergedActiveKey(key);
    onChange(key);
  }, [onChange]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Tabs.styles.tabsList,
    className: (0, _clsx["default"])({
      'grui pb-0': type === 'small'
    }, className),
    children: [typeof onGoBack === 'function' && (0, _jsxRuntime.jsx)("div", {
      type: type,
      css: [_Tabs.styles.backBtnWrapper, type === 'small' && _Tabs.styles.backBtnWrapperSmall, process.env.NODE_ENV === "production" ? "" : ";label:Tabs;"],
      children: (0, _jsxRuntime.jsx)("button", {
        type: "button",
        css: _elements.button.styles.preflight,
        "aria-label": "Go back",
        onClick: onGoBack,
        children: (0, _jsxRuntime.jsx)("span", {})
      })
    }), tabs.map(function (_ref2) {
      var key = _ref2.key,
          tabName = _ref2.tabName,
          disabled = _ref2.disabled;
      return (0, _jsxRuntime.jsx)(_Tab["default"], {
        itemKey: key,
        type: type,
        active: mergedActiveKey === key,
        disabled: disabled,
        ref: getTabRef(key),
        onClick: handleClickTab,
        children: tabName
      }, key);
    }), type !== 'small' && (0, _jsxRuntime.jsx)("div", {
      className: "tabs-ink-bar",
      css: _Tabs.styles.inkBar,
      style: inkBarStyle
    })]
  });
};

Tabs.propTypes = {
  tabs: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string,
    tabName: _propTypes.node,
    disabled: _propTypes.bool
  })).isRequired,

  /**
   * Current TabPane's key: control active key without clicking titles
   */
  activeKey: _propTypes.string,

  /**
   * Initial active TabPane's key, if activeKey is not set
   */
  defaultActiveKey: _propTypes.string,
  type: (0, _propTypes.oneOf)(['big', 'small']),
  className: _propTypes.node,

  /**
   * OnChange of the active key
   */
  onChange: _propTypes.func.isRequired,

  /**
   * Callback for handling go back:
   * if the function is passed, will show go back button
   */
  onGoBack: _propTypes.func
};
Tabs.defaultProps = {
  activeKey: undefined,
  defaultActiveKey: undefined,
  type: 'big',
  className: undefined,
  onGoBack: undefined
};
var _default = Tabs;
exports["default"] = _default;
//# sourceMappingURL=Tabs.js.map